import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

import GiftCard5000 from '../../../../../../../../assets/bank/giftcards/giftcard_5000.png';
import GiftCard30000 from '../../../../../../../../assets/bank/giftcards/giftcard_30000.png';
import GiftCard150000 from '../../../../../../../../assets/bank/giftcards/giftcard_150000.png';
import GiftCard400000 from '../../../../../../../../assets/bank/giftcards/giftcard_400000.png';
import GiftCard1000000 from '../../../../../../../../assets/bank/giftcards/giftcard_1000000.png';

const giftcards = [
  {
    src: GiftCard5000,
    points: '5.000',
    price: '5.000',
    multiplier: 1,
    color: '#A35E9F',
  },
  {
    src: GiftCard30000,
    points: '15.000',
    price: '30.000',
    multiplier: 2,
    color: '#A35E9F',
  },
  {
    src: GiftCard150000,
    points: '50.000',
    price: '150.000',
    multiplier: 3,
    color: '#DA3F7D',
  },
  {
    src: GiftCard400000,
    points: '100.000',
    price: '400.000',
    multiplier: 4,
    color: '#DF6622',
  },
  {
    src: GiftCard1000000,
    points: '200.000',
    price: '1.000.000',
    multiplier: 5,
    color: '#DCA626',
  },
];

import noSubscribedStyle from '../styles';

const WhatRedeem = (props) => {
  const { mobile } = props;
  const classes = noSubscribedStyle({ mobile });

  return (
    <React.Fragment>
      <Typography className={classes.tabPanelTitle}>
        Canjea Gift Cards
      </Typography>
      <Typography className={classes.tabPanelSubtitle}>
        Multiplica el valor de tus Ripley Puntos Go hasta x5 con las Gift Cards
        y llévate lo que quieras de la tienda.
      </Typography>
      <div className={classes.divFourGridTitle}>
        <span>Gift Card</span>
        <span>Canjeas por</span>
        <span>Multiplicador</span>
        <span>Valor en pesos</span>
      </div>
      {giftcards.map((giftcard) => (
        <div key={giftcard.multiplier} className={classes.divFourGrid}>
          <div className={classes.circleContainer}>
            <img width={mobile && 60} src={giftcard.src} />
          </div>
          <div>
            <span>
              {!mobile && <br />}
              {giftcard.points} puntos
            </span>
          </div>
          <div className={classes.circleContainer}>
            <div
              className={classes.circle}
              style={{ background: giftcard.color }}
              data-cy={'circleMultiplier'}
            >
              X {giftcard.multiplier}
            </div>
          </div>
          <span style={{ color: giftcard.color }}>
            <br />${giftcard.price}
          </span>
        </div>
      ))}
    </React.Fragment>
  );
};

WhatRedeem.propTypes = {
  mobile: PropTypes.bool,
};

export default WhatRedeem;
